import * as React from "react";
function SvgDash(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path d="M7 11a1 1 0 100 2h10a1 1 0 100-2H7z" fill="currentcolor" />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgDash);
export default ForwardRef;
